import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '10', label: 'Criado' },
			{ value: '20', label: 'Aprovado' },
			{ value: '30', label: 'Pendente' },
			{ value: '40', label: 'Concluído' },
			{ value: '50', label: 'Cancelado' }
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

